var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"10px"}}),_c('div',{staticClass:"main contentWidth boxShadow"},[_c('div',{staticClass:"flex tabs-content"},[_c('Tabs',{attrs:{"list":_vm.list}})],1),_c('JobCard'),_c('JobCard'),_c('JobCard')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }